/**
 * ui/thumbnail-cache.js
 * Bộ nhớ đệm IndexedDB cho thumbnail thẻ Customizer.
 * Giá trị lưu là Blob (ưu tiên) hoặc chuỗi dataURL (nhánh dự phòng khi toBlob không dùng được).
 * Mọi thao tác đều bọc try/catch: IndexedDB lỗi hoặc hết hạn ngạch thì coi như không có cache.
 */

/** Phải tăng khi đổi góc chụp, đèn hoặc cách dựng avatar mẫu để bỏ ảnh cũ trong cache. */
export const THUMB_VERSION = 2;

const DB_NAME = 'vas_thumbnails_db';
const DB_VERSION = 1;
const STORE_NAME = 'thumbnails';

let dbPromise = null;

export function thumbKey(kind, value) {
  return `${kind}:${value}:${THUMB_VERSION}`;
}

function openDb() {
  if (!dbPromise) {
    dbPromise = new Promise((resolve) => {
      try {
        if (typeof indexedDB === 'undefined') {
          resolve(null);
          return;
        }
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
          const db = req.result;
          if (!db.objectStoreNames.contains(STORE_NAME)) db.createObjectStore(STORE_NAME);
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => resolve(null);
        req.onblocked = () => resolve(null);
      } catch {
        resolve(null);
      }
    });
  }
  return dbPromise;
}

/** @returns {Promise<Blob|string|null>} */
export async function getCachedThumb(key) {
  try {
    const db = await openDb();
    if (!db) return null;
    return await new Promise((resolve) => {
      try {
        const req = db.transaction(STORE_NAME, 'readonly').objectStore(STORE_NAME).get(key);
        req.onsuccess = () => resolve(req.result || null);
        req.onerror = () => resolve(null);
      } catch {
        resolve(null);
      }
    });
  } catch {
    return null;
  }
}

/** @param {Blob|string} data */
export async function setCachedThumb(key, data) {
  try {
    const db = await openDb();
    if (!db) return false;
    return await new Promise((resolve) => {
      try {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        tx.objectStore(STORE_NAME).put(data, key);
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => resolve(false);
        tx.onabort = () => resolve(false);
      } catch {
        resolve(false);
      }
    });
  } catch {
    return false;
  }
}
